export class TypeaheadOptions {
    constructor(options) {
        Object.assign(this, options);
    }
}
//# sourceMappingURL=typeahead-options.class.js.map